class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleSummaryClick = this.handleSummaryClick.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);

    this.addEventListener('mouseenter', this.handleMouseEnter);
    this.addEventListener('mouseleave', this.handleMouseLeave);
    this.summary.addEventListener('click', this.handleSummaryClick);
    window.addEventListener('resize', this.handleWindowResize);
  }

  isDesktopMenu() {
    return window.matchMedia('(min-width: 990px) and (hover: hover)').matches;
  }

  openMenu() {
    if (!this.mainDetailsToggle) return;

    document.querySelectorAll('header-menu details[open]').forEach((details) => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', false);
      }
    });

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
    }

    this.summary.setAttribute('aria-expanded', true);
    this.syncDesktopPanelPosition();
  }

  handleMouseEnter() {
    if (!this.isDesktopMenu()) return;
    this.openMenu();
  }

  handleMouseLeave() {
    if (!this.isDesktopMenu()) return;
    this.close();
  }

  handleSummaryClick(event) {
    if (!this.isDesktopMenu()) return;

    event.preventDefault();
    this.openMenu();
  }

  handleWindowResize() {
    if (!this.isDesktopMenu()) {
      this.close();
      return;
    }

    if (this.mainDetailsToggle?.open) {
      this.syncDesktopPanelPosition();
    }
  }

  syncDesktopPanelPosition() {
    if (!this.isDesktopMenu() || !this.content) return;

    const headerRect = this.header?.getBoundingClientRect();
    const desktopMenuBarRect = this.header?.querySelector('.header__inline-menu')?.getBoundingClientRect();
    const summaryRect = this.summary?.getBoundingClientRect();
    const panelViewportTop = Math.floor(desktopMenuBarRect?.bottom || summaryRect?.bottom || headerRect?.bottom || 0) - 1;
    const panelInsetTop = Math.max(panelViewportTop - Math.floor(headerRect?.top || 0), 0);

    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${panelViewportTop}px`);
    document.documentElement.style.setProperty('--header-menu-panel-top-desktop', `${panelInsetTop}px`);
    this.content.style.top = `${panelInsetTop}px`;
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (this.mainDetailsToggle.open) {
      this.syncDesktopPanelPosition();
    }
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.handleMouseEnter);
    this.removeEventListener('mouseleave', this.handleMouseLeave);
    this.summary?.removeEventListener('click', this.handleSummaryClick);
    window.removeEventListener('resize', this.handleWindowResize);
  }
}

customElements.define('header-menu', HeaderMenu);
